import {createSlice} from "@reduxjs/toolkit";
import { updateReviewData} from "services/review/review";

const initialState = {
    review : {
        data : [],
        isLoading: false,
        isSuccess: false,
        errorMessage: ''
    }
}

export const updateReviewSlice = createSlice({
    name: 'updateReview',
    initialState,
    extraReducers:{
        [updateReviewData.pending]:(state) =>{
            state.review.isLoading = true
            state.review.errorMessage = '';
        },
        [updateReviewData.fulfilled]: (state, {payload}) =>{
            state.review.isSuccess = true;
            state.review.isLoading = false;
            state.review.data = payload;
        },
        [updateReviewData.rejected]: (state, {payload}) =>{
            state.review.isSuccess = false;
            state.review.isLoading = false;
            state.review.errorMessage = payload;
        }
    }
})

export default updateReviewSlice.reducer;